import type { ReactNode } from 'react';

export interface BoardHeaderProps {
  eyebrow: string;
  title: string;
  body: string;
  children?: ReactNode;
}

/** The board's page heading: the eyebrow line, the title, the lead paragraph. */
export const BoardHeader = ({ eyebrow, title, body, children }: BoardHeaderProps) => (
  <header className="space-y-2">
    <p className="text-xs font-medium uppercase tracking-[0.14em] text-muted-foreground">{eyebrow}</p>
    <h1 className="max-w-4xl text-2xl font-semibold leading-tight text-foreground">{title}</h1>
    <p className="max-w-4xl text-sm leading-relaxed text-muted-foreground">{body}</p>
    {children}
  </header>
);
